import httpClient from "../httpClient";
import { API_COMPLICATION_CREATE } from "../config";

const createComplication = {
    create: (data) => httpClient.post(API_COMPLICATION_CREATE, data),
};

export default createComplication;
